<template>
  <div class="inicio" style="background-color: #ffffff">
    <barraNavegacionPublic class="barraNavegacionPublic"></barraNavegacionPublic>
      <div class="cuerpo">
      <cabecera></cabecera>
      <!--<hr style="border-top: 1px solid rgba(0,0,0,0)">-->
      <grupoCategoriasPublic class="mt-2 mt-sm-4"></grupoCategoriasPublic>
    </div>
    <footerPublic class="footerPublic mt-1 mt-md-0"></footerPublic>
  </div>
</template>

<script>
  import barraNavegacionPublic from './share/barraNavegacion';
  import cabecera from './fragmentosInicio/cabecera';
  import grupoCategoriasPublic from './fragmentosInicio/grupoCategorias';
  import footerPublic from './share/footer';

  export default {
    name: "InicioPublico",
    data() {
      return {
        styleObject: {
          general: {
            barraSuperiorEinferior: {
              fondo: {'background-color': '#4b4b4b'},
              colorTexto: {"color": "#ff3668", "font-size": "22px"},
            },
            fondoBase: {'background-color': '#e7e6ed'},
            fondoSecundario: {'background-color': '#fafafa'}
          },
          inicio: {
            cabecera: {color: '#ff3760', "font-weight": "900", "font-size": "30px"}
          },
        }
      }
    },
    created() {
      this.cargarEstilos();
      $(document).ready(function () {
        $('body').bootstrapMaterialDesign();
      });
    },
    components: {
      barraNavegacionPublic,
      cabecera,
      grupoCategoriasPublic,
      footerPublic
    },
    methods: {
      cargarEstilos() {
       /* axios.get(`${listApiUrl.BASE_URL_PRODUCCION + listApiUrl.API_URL_PUBLICO + listApiUrl.API_URL_ESTILO}/${this.$route.params.cliente}`).then(resp => {
          EventBus.$emit('estilos', this.styleObject);
        });*/
      }
    }
  }
</script>

<style scoped lang="scss">
  .inicio {
    min-height: 100vh;
  }

  .barraNavegacionPublic {
    height: 8vh;
  }

  .cuerpo {
    min-height: 67vh;
    /*margin-bottom: 25px;*/
  }

  .footerPublic {
    margin-top: -20px;
    height: 15vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/publico/inicio.vue